/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Modal } from 'antd';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import Session from '../../../Service/Session';

import { deleteNavigationalWindowObject, formValidator, setNavigationalWindowObject } from '../../../AppUtil/AppUtil';
import { logPageView } from '../../../AppUtil/analytics';

import BasicButtons from '../../Common/BasicButtons';
import BasicCountryCodeField from '../../Common/BasicCountryCodeField';
import BasicInputField from '../../Common/BasicInputField';
import BasicSelectField from '../../Common/BasicSelectField';
import BasicTextField from '../../Common/BasicTextField';
import ShowPassword from '../../Common/ShowPassword';
import '../style.css';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;
const SUPPORTED_LANGUAGES = window.AppConfig.SUPPORTED_LANGUAGES;

const styles = theme => ({
	paper: {
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
		textAlign: 'center'
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	blockdiv: {
		textAlign: 'center'
	},
	displayFlex: {
		display: 'flex'
	},
	center: {
		textAlign: 'center'
	},
	uploadIdCss: {
		display: 'flex',
		color: 'red'
	}
});

class Form extends Component {
	constructor(props) {
		super(props);
		// this.inputLabel = React.createRef();

		this.state = {
			_changePassword: true,
			_confirmPassword: true,
			isLoading: false,
			isModalOpen: false,
			isCheckboxChecked: false,
			_frontIdImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: ''
			},
			_backIdImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: ''
			},
			_selfieImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: ''
			},
			_countryCode: this.props.user.countryCode || '+63',
			_agreeTermsAndConditions: false,
			_agreeMarketingTerms: false,
			_signUpForm: {
				firstName: {
					value: this.props.user.first_name || '',
					placeholder: 'label.first_name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_first_name'
						},
						pattern: {
							value: PATTERN.NAME,
							errorMsg: 'error_message.invalid_first_name'
						}
					},
					error_text: ''
				},
				lastName: {
					value: this.props.user.last_name || '',
					placeholder: 'label.last_name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_last_name'
						},
						pattern: {
							value: PATTERN.NAME,
							errorMsg: 'error_message.invalid_last_name'
						}
					},
					error_text: ''
				},
				birthDate: {
					value: '',
					isValid: false,
					isTouched: false,
					error_text: ''
				},
				emailId: {
					value: this.props.user.emailId || '',
					placeholder: 'label.email',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_email'
						},
						pattern: {
							value: PATTERN.EMAIL,
							errorMsg: 'error_message.invalid_email'
						}
					},
					error_text: ''
				},
				phone: {
					value: this.props.user.phone || '',
					placeholder: 'label.contact',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_contact'
						},
						pattern: {
							value: PATTERN.CONTACT,
							errorMsg: 'error_message.invalid_contact'
						}
					},
					error_text: ''
				},
				// address: {
				// 	value: this.props.user.address || '',
				// 	placeholder: 'label.address',
				// 	isValid: true,
				// 	isTouched: false,
				// 	validationRules: {
				// 		isRequired: {
				// 			value: false,
				// 			errorMsg: 'error_message.required_address'
				// 		}
				// 	},
				// 	error_text: ''
				// },
				state: {
					value: this.props.user.state || '',
					placeholder: 'label.region',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_region'
						}
					},
					error_text: ''
				},
				password: {
					value: '',
					placeholder: 'label.password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_password'
						},
						pattern: {
							value: PATTERN.PASSWORD,
							errorMsg: 'error_message.password_pattern'
						}
					},
					error_text: ''
				},
				confirm_password: {
					value: '',
					placeholder: 'label.confirm_new_password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_confirm_password'
						}
					},
					error_text: ''
				}
			}
		};
	}

	validateBirthdate(birthDateStr) {
		// Handle empty or invalid date strings
		if (!birthDateStr || birthDateStr.trim() === '') {
			return 'Please enter your Birth Date.'; // Customize error message as needed
		}

		try {
			// Parse the birthdate string into a Date object
			const birthDate = new Date(birthDateStr);

			// Get birth year
			const birthYear = birthDate.getFullYear();

			const maxYear = new Date().getFullYear() - 18;
			if (birthYear > maxYear) return 'You must be at least 18 years old to proceed.'; // Customize error message as needed

			return ''; // No validation error
		} catch (error) {
			console.error('Invalid birthdate format:', error);
			return 'Invalid birthdate format. Please enter a valid date.'; // Customize error message as needed
		}
	}

	handleTermsConditionChange = e => {
		this.setState({
			_agreeTermsAndConditions: e.target.checked
		});
	};

	handleMarketingChange = e => {
		this.setState({
			_agreeMarketingTerms: e.target.checked
		});
	};

	/**
	 * This function handle all input change event inside sign up form
	 * @returns {void}
	 */
	handelInputChange = e => {
		this.props.resetFormError();

		const name = e.target.name;
		let value = e.target.value;

		const signUpForm = {
			...this.state._signUpForm
		};
		const updatedFormElement = {
			...signUpForm[name]
		};

		if (name === 'birthDate') {
			if (this.validateBirthdate(value)) {
				updatedFormElement.isValid = false;
				updatedFormElement.error_text = this.validateBirthdate(value);
			} else {
				updatedFormElement.isValid = true;
				updatedFormElement.error_text = '';
			}

			updatedFormElement.value = value;
			signUpForm[name] = updatedFormElement;

			this.setState({
				_signUpForm: signUpForm
			});

			return;
		}

		if (name === 'phone') {
			value = value.replace(/[^\d]/g, '');
		}

		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		signUpForm[name] = updatedFormElement;
		this.setState({
			_signUpForm: signUpForm
		});
	};

	/**
	 * This function handle submit sign up form
	 * @returns {Promise<void>}
	 */

	onModalOpen = e => {
		deleteNavigationalWindowObject();
		e.preventDefault();
		this.props.resetFormError();

		if (!this.formValidator()) {
			return false;
		}
		if (
			!this.documentValidator('_frontIdImage') ||
			!this.documentValidator('_backIdImage') ||
			!this.documentValidator('_selfieImage')
		) {
			return false;
		}

		this.setState({ isModalOpen: true });
	};

	onModalCancel = () => {
		if (this.state.isLoading) return;
		this.setState({ isModalOpen: false });
	};

	onSubmitHandler = async e => {
		this.setState({ isLoading: true });
		const signUpForm = {
			...this.state._signUpForm
		};
		const countryCode = this.state._countryCode;

		// checking for invitation code
		const params = new URLSearchParams(window.location.search);
		const invitationCode = params.get('invitationCode');
		const referralSource = Session.get('campaign') || {
			utm_source: null,
			utm_campaign: null
		};
		let locale = 'en-US';
		const tenant = Session.get('TENANT');
		if (SUPPORTED_LANGUAGES.includes(this.props.i18n.language)) {
			locale = this.props.i18n.language;
		}

		const stateValue = this.props.supportedStates
			.filter(s => s.label === signUpForm.state.value)
			.map(s => s.value)[0];

		const user = {
			email: signUpForm.emailId.value.toLowerCase(),
			phone: countryCode + signUpForm.phone.value,
			username: countryCode + signUpForm.phone.value,
			first_name: signUpForm.firstName.value,
			last_name: signUpForm.lastName.value,
			dob: signUpForm.birthDate.value,
			// address: signUpForm.address.value,
			state: stateValue,
			organization_id: 1,
			password: signUpForm.password.value,
			referral_source: referralSource.utm_source,
			referral_campaign: referralSource.utm_campaign,
			locale: locale,
			tenant_id: tenant.id
		};

		if (invitationCode) {
			user.registration_code = invitationCode;
		}
		await this.props.onSubmit(user, [
			{ id: 'frontId', file: this.state._frontIdImage },
			{ id: 'backId', file: this.state._backIdImage },
			{ id: 'selfie', file: this.state._selfieImage }
		]);
		this.setState({ isLoading: false, isModalOpen: false });
	};

	/**
	 * This function validate all field in login form
	 */
	formValidator = () => {
		const form = {
			...this.state._signUpForm
		};
		let flag = true;
		const [updatedForm, isFormValid] = formValidator(form);
		if (
			updatedForm.confirm_password.isValid &&
			updatedForm.confirm_password.isTouched &&
			updatedForm.confirm_password.value !== updatedForm.password.value
		) {
			updatedForm.confirm_password.isValid = false;
			updatedForm.confirm_password.error_text = 'error_message.confirmPasswordMissMatch'; // NOSONAR
			flag = false;
		}

		if (this.validateBirthdate(updatedForm.birthDate.value)) {
			updatedForm.birthDate.isValid = false;
			updatedForm.birthDate.error_text = this.validateBirthdate(updatedForm.birthDate.value); // NOSONAR
			flag = false;
		}

		if (
			!updatedForm.phone.value.startsWith('9') &&
			updatedForm.phone.value.length > 0 &&
			this.state._countryCode === '+63'
		) {
			updatedForm.phone.isValid = false;
			updatedForm.phone.error_text = 'Phone Number must start with 9';
			flag = false;
		}

		this.documentValidator('_frontIdImage');
		this.documentValidator('_backIdImage');
		this.documentValidator('_selfieImage');
		this.setState({
			_signUpForm: updatedForm
		});

		return isFormValid && flag;
	};

	documentValidator = imageName => {
		const image = this.state[imageName].value;

		this.setState({
			[imageName]: { ...this.state[imageName], imageError: '' }
		});

		let flag = true;

		if (image) {
			if (image.size > 2 * 1024 * 1024) {
				this.setState({
					[imageName]: {
						...this.state[imageName],
						isValid: false,
						imageError: 'File is more than 2MB. Upload image file not more than 2MB'
					}
				});
				flag = false;
			} else if (!image.type.startsWith('image/')) {
				this.setState({
					[imageName]: {
						...this.state[imageName],
						isValid: false,
						imageError: 'Upload a valid image'
					}
				});
				flag = false;
			} else {
				this.setState({
					[imageName]: { ...this.state[imageName], isValid: true }
				});
			}
		} else {
			flag = false;
			this.setState({
				[imageName]: {
					...this.state[imageName],
					isThereImage: false,
					isValid: false,
					imageError: 'Please upload a JPG or PNG file only'
				}
			});
		}

		return flag;
	};

	setAlreadyExistError = (field, error) => {
		const form = {
			...this.state._signUpForm
		};
		form[field].isValid = false;
		form[field].error_text = error;
		this.setState({
			_signUpForm: form
		});
	};

	setLabelWidth = () => {
		if (this.inputLabel) {
			this.setState({
				labelWidth: this.inputLabel.current.offsetWidth
			});
		}
	};

	componentDidUpdate(prevProps) {
		if (prevProps.isEmailDuplicate !== this.props.isEmailDuplicate && this.props.isEmailDuplicate) {
			this.setAlreadyExistError('emailId', 'error_message.email_already_exists');
		}
		if (prevProps.isMobileDuplicate !== this.props.isMobileDuplicate && this.props.isMobileDuplicate) {
			this.setAlreadyExistError('phone', 'error_message.mobile_already_exists');
		}
	}

	termsConditionsLabel = () => {
		return (
			<p style={{ fontWeight: 'initial' }}>
				<Trans i18nKey="signup.terms_conditions">
					I agree to the LendAmi
					<a href={this.props.t('signup.terms_link')} target="_blank">
						Terms of Use
					</a>
					and
					<a href={this.props.t('signup.privacy_link')} target="_blank">
						Privacy Policy.
					</a>
				</Trans>
			</p>
		);
	};

	termsMarketingLabel = () => {
		return <p style={{ fontWeight: 'initial' }}>{this.props.t('signup.marketing_terms')}</p>;
	};

	setCountryCode = e => {
		this.setState({
			_countryCode: e.target.value,
			_signUpForm: {
				...this.state._signUpForm,
				phone: {
					...this.state._signUpForm.phone,
					value: ''
				}
			}
		});
	};

	keepOnPage = e => {
		e.returnValue = '';
	};

	componentDidMount() {
		this.setLabelWidth();
		logPageView('/app/account-register'); // NOSONAR
		const dataForPopUp = {
			title: 'sweetalert_title.are_you_sure',
			messageKey: 'sweetalert.continue_on_sign_up',
			message: {},
			label: ['security_privacy_practices']
		};
		window.addEventListener('beforeunload', this.keepOnPage);
		setNavigationalWindowObject(dataForPopUp);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.keepOnPage);
		deleteNavigationalWindowObject();
	}

	onFileChange = async e => {
		const name = e.target.name;

		try {
			const file = e.target.files[0];
			const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

			if (!file) return;

			if (allowedExtensions.test(file.name)) {
				const reader = new FileReader();
				reader.readAsDataURL(file); // Read the file as a data URL

				reader.onload = preview => {
					this.setState({
						[name]: {
							...this.state[name],
							value: file, // commented out due to error
							// selectedFile: e.target.files[0],
							imagePreview: preview.target.result,
							isValid: true,
							isThereImage: true
						}
					});
				};
			} else {
				this.setState({
					[name]: {
						...this.state[name],
						value: null,
						// selectedFile: null,
						isValid: false,
						isThereImage: false
					}
				});
			}
			this.documentValidator(name);
		} catch (err) {
			console.log(err);
		}
	};

	render() {
		// NOSONAR
		const { classes } = this.props;
		const { t } = this.props;
		const params = new URLSearchParams(window.location.search);

		const name = params.get('name');
		const signUpTitle = 'SIGN UP';
		const signUpDescription = 'Create an account to start using LendAmi';
		const changeIcon = this.state._changePassword === true ? false : true;
		const changeIconConfirm = this.state._confirmPassword === true ? false : true;

		const filteredFields = Object.entries(this.state._signUpForm)
			.filter(([key, value]) => key !== 'password' && key !== 'confirm_password')
			.map(([oldKey, value]) => {
				// Rename keys with a mapping object
				const newKeyMap = {
					EmailID: 'Email',
					FirstName: 'First Name',
					LastName: 'Last Name'
				};
				// Use the new key based on the mapping or fallback to the original key
				const newKey = newKeyMap[oldKey] || oldKey;
				return [newKey, value];
			});

		const imageData = [
			{ title: 'Front ID Image Preview:', alt: 'Front ID Preview', src: this.state._frontIdImage.imagePreview },
			{ title: 'Back ID Image Preview:', alt: 'Back ID Preview', src: this.state._backIdImage.imagePreview },
			{ title: 'Selfie Image Preview:', alt: 'Selfie Preview', src: this.state._selfieImage.imagePreview }
		];

		const ImageWithTitle = ({ title, src, alt }) => {
			return (
				<div>
					<p>{title}</p>
					<img
						src={src}
						alt={alt}
						width="300" // Specify a reasonable width
						height="200" // Specify a reasonable height
						style={{ objectFit: 'cover', display: 'block', margin: '0 auto' }} // Ensure the image fills its container without distortion
					/>
				</div>
			);
		};

		return (
			<Container component="main" maxWidth="md">
				<Modal
					onOk={this.onSubmitHandler}
					confirmLoading={this.state.isLoading}
					okButtonProps={{ disabled: !this.state.isCheckboxChecked }}
					title="Are the details correct?"
					open={this.state.isModalOpen}
					cancelText="Back"
					okText="Continue"
					onCancel={this.onModalCancel}>
					<div>
						{filteredFields.map(([key, value]) => {
							if (key === 'firstName') key = 'First Name';
							if (key === 'lastName') key = 'Last Name';
							if (key === 'emailId') key = 'Email';

							if (key === 'phone') key = 'Mobile Number';
							if (key === 'state') key = 'Region';

							if (key === 'birthDate') {
								key = 'Birthdate';
								value.value = new Date(value.value).toLocaleDateString();
							}

							return (
								<p key={key}>
									{key}: <strong>{value.value}</strong>
								</p>
							);
						})}

						<div style={{ display: 'flex', flexDirection: 'column', rowGap: '25px' }}>
							{imageData.map(image => (
								<ImageWithTitle key={image.title} {...image} /> // Spread image object props
							))}
						</div>

						<div className="aggrement-container">
							<input
								type="checkbox"
								id="terms-and-aggrement"
								name="terms-and-aggrement"
								onChange={() => {
									this.setState(prevState => ({
										isCheckboxChecked: !prevState.isCheckboxChecked
									}));
								}}
							/>{' '}
							<label for="terms-and-aggrement" style={{ margin: 0 }}>
								I have reviewed the details and confirm that they are correct.
							</label>
						</div>
					</div>
				</Modal>

				<CssBaseline />
				<Paper className={classes.paper} id="form-opacity-none">
					<Grid container justify="center" spacing={3} style={{ backgroundColor: '' }}>
						<Grid
							className="signup-form-wrapper"
							item
							md={8}
							sm={8}
							xs={12}
							style={{ backgroundColor: '', padding: 20 }}>
							<Paper
								className="no-shadow"
								id="signup-form"
								style={{
									backgroundColor: '',
									padding: 15,
									borderRadius: '25px'
								}}>
								<div className={classes.paper}>
									<Typography component="h1" variant="h5">
										{/* {t('signup.create_account')} */}
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center'
											}}>
											<label className="signup-title">{signUpTitle}</label>
											<label className="signup-description">{signUpDescription}</label>
										</div>
									</Typography>
									<Typography className="text-center light-gray">
										{name && params.get('invitationCode')
											? t('signup.main_heading', {
													name: name
											  })
											: ''}
									</Typography>
									<form className={classes.form} noValidate onSubmit={this.onSubmitHandler}>
										<BasicTextField
											error={
												!this.state._signUpForm.firstName.isValid &&
												this.state._signUpForm.firstName.isTouched
											}
											helperText={t(this.state._signUpForm.firstName.error_text)}
											id="firstName"
											label={t(this.state._signUpForm.firstName.placeholder)}
											name="firstName"
											// onChange={(e)=>{this.handelInputChange(e)}}
											onChange={this.handelInputChange}
											value={this.state._signUpForm.firstName.value}
											placeholder="First Name"
											required
										/>
										<BasicTextField
											error={
												!this.state._signUpForm.lastName.isValid &&
												this.state._signUpForm.lastName.isTouched
											}
											helperText={t(this.state._signUpForm.lastName.error_text)}
											id="lastName"
											label={t(this.state._signUpForm.lastName.placeholder)}
											name="lastName"
											onChange={e => {
												this.handelInputChange(e);
											}}
											value={this.state._signUpForm.lastName.value}
											placeholder="Last Name"
											required
											marginTop={10}
										/>

										<BasicTextField
											id="birthDate"
											label="Birthdate"
											helperText={t(this.state._signUpForm.birthDate.error_text)}
											error={this.state._signUpForm.birthDate.error_text}
											onChange={e => {
												this.handelInputChange(e);
											}}
											required
											type="date"
											name="birthDate"
											marginTop={10}
										/>
										<BasicTextField
											error={
												!this.state._signUpForm.emailId.isValid &&
												this.state._signUpForm.emailId.isTouched
											}
											disabled={!this.state._signUpForm.birthDate.isValid}
											helperText={t(this.state._signUpForm.emailId.error_text)}
											id="emailId"
											label={t(this.state._signUpForm.emailId.placeholder)}
											name="emailId"
											onChange={e => {
												this.handelInputChange(e);
											}}
											value={this.state._signUpForm.emailId.value}
											placeholder="Email"
											required
											marginTop={10}
											toolTip="Kindly be advised that once your wallet has been created, you will no longer be able to change the mobile number and email address associated to this account. Please ensure you enter the correct primary information"
										/>
										<Grid
											style={{
												backgroundColor: '',
												position: 'relative',
												paddingTop: '15px'
											}}
											container
											justify="center"
											spacing={1}>
											<label
												className="auth-form-input-header"
												style={{
													backgroundColor: '',
													position: 'absolute',
													left: 5
												}}>
												{'Mobile Number' + '*'}
											</label>
											<Grid item sm={2} xs={3}>
												<BasicCountryCodeField
													setCountryCode={this.setCountryCode}
													value={this.state._countryCode}
												/>
											</Grid>
											<Grid item sm={10} style={{ marginTop: '16px' }} xs={9}>
												<BasicInputField
													maxLength={10}
													error={
														!this.state._signUpForm.phone.isValid &&
														this.state._signUpForm.phone.isTouched
													}
													helperText={t(this.state._signUpForm.phone.error_text)}
													onChange={e => {
														this.handelInputChange(e);
													}}
													disabled={!this.state._signUpForm.birthDate.isValid}
													className="bold-important"
													label={t(this.state._signUpForm.phone.placeholder)}
													value={this.state._signUpForm.phone.value}
													toolTip="Kindly be advised that once your wallet has been created, you will no longer be able to change the mobile number and email address associated to this account. Please ensure you enter the correct primary information"
												/>
											</Grid>
										</Grid>
										<BasicSelectField
											error={
												!this.state._signUpForm.state.isValid &&
												this.state._signUpForm.state.isTouched
											}
											disabled={!this.state._signUpForm.birthDate.isValid}
											id="demo-simple-select-outlined"
											name="state"
											label="Region"
											placeholder="Region"
											onChange={e => {
												this.handelInputChange(e);
											}}
											value={this.state._signUpForm.state.value}
											optionsValues={this.props.supportedStates.map((state, index) => {
												return { label: state.label };
											})}
											helperText={
												!this.state._signUpForm.state.isValid &&
												this.state._signUpForm.state.isTouched ? (
													<FormHelperText id="text-red">
														{t(this.state._signUpForm.state.error_text)}
													</FormHelperText>
												) : (
													''
												)
											}
											marginTop={10}
										/>
										<div className="reminders-upload">
											<p>Reminders for Uploading of Images:</p>
											<ul>
												<li>
													Max file size is <span className="bold-important">2MB</span>
												</li>
												<li>Make sure photo is clear</li>
												<li>Make sure that ID is not cut</li>
												<li>Make sure that face is not covered</li>
											</ul>
										</div>
										<BasicTextField
											id="_frontIdImage"
											label={'Upload Front ID Image*'}
											onChange={e => this.onFileChange(e)}
											error={
												!this.state._frontIdImage.isValid ||
												!this.state._frontIdImage.isThereImage
											}
											helperText={
												this.state._frontIdImage.isValid
													? ''
													: this.state._frontIdImage.imageError
											}
											disabled={!this.state._signUpForm.birthDate.isValid}
											required
											type="file"
											name="_frontIdImage"
											marginTop={10}
										/>
										<BasicTextField
											id="_backIdImage"
											label={'Upload Back ID Image*'}
											onChange={e => this.onFileChange(e)}
											error={
												!this.state._backIdImage.isValid ||
												!this.state._backIdImage.isThereImage
											}
											helperText={
												this.state._backIdImage.isValid
													? ''
													: this.state._backIdImage.imageError
											}
											disabled={!this.state._signUpForm.birthDate.isValid}
											required
											type="file"
											name="_backIdImage"
											marginTop={10}
										/>
										<BasicTextField
											id="_selfieImage"
											label={'Upload Selfie Image with ID'}
											onChange={e => this.onFileChange(e)}
											error={
												!this.state._selfieImage.isValid ||
												!this.state._selfieImage.isThereImage
											}
											helperText={
												this.state._selfieImage.isValid
													? ''
													: this.state._selfieImage.imageError
											}
											required
											disabled={!this.state._signUpForm.birthDate.isValid}
											type="file"
											name="_selfieImage"
											marginTop={10}
										/>
										<BasicTextField
											error={
												!this.state._signUpForm.password.isValid &&
												this.state._signUpForm.password.isTouched
											}
											helperText={t(this.state._signUpForm.password.error_text)}
											disabled={!this.state._signUpForm.birthDate.isValid}
											id="password"
											type={this.state._changePassword ? 'password' : 'text'}
											label={t(this.state._signUpForm.password.placeholder)}
											name="password"
											onChange={e => {
												this.handelInputChange(e);
											}}
											icon={
												<ShowPassword
													onClick={() => {
														this.setState({ _changePassword: changeIcon });
													}}
													changeIcon={changeIcon}
												/>
											}
											value={this.state._signUpForm.password.value}
											placeholder="Password"
											required
											marginTop={10}
										/>
										<BasicTextField
											error={
												!this.state._signUpForm.confirm_password.isValid &&
												this.state._signUpForm.confirm_password.isTouched
											}
											helperText={t(this.state._signUpForm.confirm_password.error_text)}
											disabled={!this.state._signUpForm.birthDate.isValid}
											id="confirm_password"
											type={this.state._confirmPassword ? 'password' : 'text'}
											label={t(this.state._signUpForm.confirm_password.placeholder)}
											name="confirm_password"
											onChange={e => {
												this.handelInputChange(e);
											}}
											icon={
												<ShowPassword
													onClick={() => {
														this.setState({ _confirmPassword: changeIconConfirm });
													}}
													changeIcon={changeIconConfirm}
												/>
											}
											value={this.state._signUpForm.confirm_password.value}
											placeholder="Confirm Password"
											required
											marginTop={10}
											onKeyPress={e => {
												if (e.key === 'Enter') {
													this.onSubmitHandler(e);
												}
											}}
										/>
										{this.props.isError && (
											<Link
												href="/"
												style={{ color: 'red', display: 'inline-block', marginTop: '2px' }}>
												{this.props.errorMessage}
											</Link>
										)}
										<div
											className={classes.blockdiv}
											style={{
												backgroundColor: '',
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
												justifyContent: 'space-between',
												marginTop: '25px',
												height: '90px'
											}}>
											<BasicButtons
												onClick={this.onModalOpen}
												type="signup"
												text="SIGN Up"
												isLoaderOn={this.props.isSignUpFormLoaderOn}
												loader={<CircularProgress disableShrink size={18} />}
											/>
											<Link
												href="#"
												onClick={e => {
													e.preventDefault();
													this.props.openSignInForm();
												}}
												variant="body2">
												{/* {t('signup.have_an_account')} */}
												<label className="login-links">lOG In INSTEAD</label>
											</Link>
										</div>
									</form>
								</div>
							</Paper>
							<Paper id="form-opacity-none">{this.props.footer}</Paper>
						</Grid>
					</Grid>
				</Paper>
			</Container>
		);
	}
}

export default withStyles(styles)(withTranslation()(Form));
